export enum HeroHorizontalContentPlacement {
  Left = 'start',
  Center = 'center',
  Right = 'end'
}
